import { useState } from 'react';

export const useMaintenanceQuickActions = (filteredJobs, handleOpenCheck, currentVesselId, passedMaintenanceHistory, domainAddJob, domainUpdateJob) => {
  const [showAddCustomModal, setShowAddCustomModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const onQuickAction = (action) => {
    switch (action) {
      case 'add':
        setShowAddCustomModal(true);
        break;
      case 'report':
        setShowReportModal(true);
        break;
      case 'settings':
        setShowSettingsModal(true);
        break;
      default:
        break;
    }
  };

  const handleSaveCustomJob = (customJob) => {
    // FT-183 FIX: Route through domain hook so React state updates immediately.
    // Previously wrote directly to localStorage, bypassing useMaintenanceJobsDomain state
    // (FT-182 v10 removed the sr:jobs:updated listener, so direct writes were invisible to the UI).
    const isEdit = !!customJob.id && filteredJobs.some(j => j.id === customJob.id);

    if (isEdit && domainUpdateJob) {
      domainUpdateJob(customJob.id, { ...customJob, custom: true });
    } else if (domainAddJob) {
      domainAddJob({ ...customJob, custom: true });
    }
  };

  // FT-182 v10: handleDeleteCustomJob removed - archiving now handled by PlannedMaintenanceTab via useMaintenanceJobsDomain

  return {
    showAddCustomModal,
    setShowAddCustomModal,
    showReportModal,
    setShowReportModal,
    showSettingsModal,
    setShowSettingsModal,
    onQuickAction,
    handleSaveCustomJob,
    maintenanceHistory: passedMaintenanceHistory || {}
  };
};
